import { Box } from '@spark-web/box';
import { Heading } from '@spark-web/heading';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { ProgressRing } from '../ProgressRing';

type ProgressIndicatorProps = { readonly time: number; readonly max: number };

export function ProgressIndicator({ time, max }: ProgressIndicatorProps) {
  return (
    <Box paddingY="large" paddingX="xlarge">
      <Stack gap="xxlarge" alignSelf="center">
        <Box display="flex" alignItems="center" justifyContent="center">
          <ProgressRing percentage={(time / max) * 100} value={time} label="seconds" />
        </Box>
        <Heading level="2" align="center">
          We're processing your application
        </Heading>
        <Text align="center">
          In less than thirty seconds, you should know if you've been successful. However, sometimes it may take longer.
          Hold tight, you'll hear from us soon.
        </Text>
      </Stack>
    </Box>
  );
}
